import { render, staticRenderFns } from "./noMore.vue?vue&type=template&id=ddf2d1ee&scoped=true&"
import script from "./noMore.vue?vue&type=script&lang=js&"
export * from "./noMore.vue?vue&type=script&lang=js&"
import style0 from "./noMore.vue?vue&type=style&index=0&id=ddf2d1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__l_ab654a11f1d2b005dc7fd011f8cb0ddc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf2d1ee",
  null
  
)

export default component.exports